<div fxLayout="row" style='overflow-x:hidden;'>
  <div fxFlex="5" *ngIf="!isPDF">
    <mat-icon class="modal-buttons" (click)="zoomIn()">zoom_in</mat-icon>
  </div>
  <div fxFlex="5" *ngIf="!isPDF">
    <mat-icon class="modal-buttons" (click)="zoomOut()">zoom_out</mat-icon>
  </div>
  <div fxFlex="5" *ngIf="!isPDF && isRotatable">
    <mat-icon class="modal-buttons" (click)="rotateImage('left')">rotate_left</mat-icon>
  </div>
  <div fxFlex="5" *ngIf="!isPDF && isRotatable">
    <mat-icon class="modal-buttons" (click)="rotateImage('right')">rotate_right</mat-icon>
  </div>
  <div fxFlex="85"></div>
  <div fxFlex="5">
    <mat-icon class="modal-buttons" (click)="onClickClose()">
      close
    </mat-icon>
  </div>
</div>
<div fxLayout="row" class="modal-content">
  <div *ngIf="!isPDF" class="image-container">
    <img 
      #image 
      [src]="imageSource" 
      crossingimage 
      onerror="src='../../../../assets/notImage.png'"
      alt="full image">
  </div>
  <div *ngIf="isPDF" class="pdf-preview-container">
    <object class="pdf-preview" type="application/pdf" [data]="pdfUrl"></object>
  </div>
</div>
